// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2024-08-21 22:16:47 +0200 (Wed, 21 Aug 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 145141 $
//  Purpose   : transcription hooks
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {get} from 'ldash'

import log from 'uix/logging'
import {useApi, useRouter} from 'uix/hooks'

export const useApiWithPuid = (name, params = {}, apiopts = {}) => {
  let {request} = useRouter()
  let puid = String(request.id).startsWith('pu') ? request.id.slice(2) : null
  return useApi(name, puid ? {id: puid, ...params} : params, apiopts)
}
